<template>
  <div>
    <div v-if="displayType === 'long'">
      <p>
        ©{{ (new Date()).getFullYear() }} Morningstar. All Rights Reserved. The information contained herein: (1) is proprietary to Morningstar and/or its content providers; (2) may not be copied or distributed; and (3) is not warranted to be accurate, complete, or timely. Neither Morningstar nor its content providers are responsible for any damages or losses arising from any use of this information. Past performance is no guarantee of future results.
      </p>
      <p>
        Style categories are defined by Morningstar. For each geographical region (style zone), large-cap stocks account for the top 70% of market capitalization; mid-cap stocks represent the next 20%; small-cap stocks represent the smallest 10%. The 7 style zones are United States, Latin America, Canada, Europe, Japan, Asia ex-Japan, Australia/New Zealand.
      </p>
      <p>
        There are five value factors and five growth factors used to determine the value/core/growth categorization.
      </p>
      <p>
        Value Factors and Weights: Price-to-projected Earnings*: 50% | Price-to-Book*: 12.5% | Price-to-Sales*: 12.5% | Price-to-Cash Flow*: 12.5% | Dividend Yield: 12.5%
      </p>
      <p>
        Growth Factors and Weights: Long-Term Projected Earnings Growth: 50% | Book Value Growth: 12.5% | Sales Growth: 12.5% | Cash Flow Growth: 12.5% | Historical Earnings Growth: 12.5%
      </p>
      <p>
        * The calculations are done with the yield form of these variables (i.e. with price in the denominator of the fraction).
      </p>
      <p>
        The five value and five growth characteristics for each individual stock are compared to those of other stocks within the same scoring group (groups based on style zone and size, for example, Europe large-caps). Stocks are then assigned Overall Value and Overall Growth scores based on the ten factors. If either growth or value is dominant, the stock is classified accordingly. If the scores for value and growth are similar in strength, the stock is classified as "core."
      </p>
      <p>
        The thresholds between value, core, and growth stocks vary to some degree over time, as the distribution of stock styles changes in each style zone. However, on average, the three stock styles each account for approximately one-third of the total capitalization in each scoring group.
      </p>
      <p>
        This Style Category Breakdown chart applies to directly held securities as well as equities held through funds. 
        <template v-if="portfolio && benchmark">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }} and {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
        <template v-else-if="portfolio">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }}.
        </template>
        <template v-else-if="benchmark">
          This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
        Style Category data from funds uses holdings as of data of most recent NPORT SEC filing.
      </p>
    </div>
    <div v-else>
      <p>
        Style categories are defined by Morningstar. For each geographical region, large-cap stocks account for the top 70% of market capitalization; mid-cap stocks represent the next 20%; small-cap stocks represent the smallest 10%. Value stocks are those priced lower relative to fundamental metrics, growth stocks have higher expected growth rates, and core (blend) stocks exhibit both value and growth characteristics.
      </p>
      <p>
        This Style Category Breakdown chart applies to directly held securities as well as equities held through funds. 
        <template v-if="portfolio && benchmark">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }} and {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
        <template v-else-if="portfolio">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }}.
        </template>
        <template v-else-if="benchmark">
          This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: 'StyleCategoryMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    breakdown() {
      const portfolio = this.portfolio?.sector_market_cap_asset_class_breakdown;
      const benchmark = this.benchmark?.sector_market_cap_asset_class_breakdown;
      return { portfolio, benchmark };
    },
    coverage() {
      return {
        portfolio: this.breakdown?.portfolio?.sector_breakdown_coverage || 0,
        benchmark: this.breakdown?.benchmark?.sector_breakdown_coverage || 0,
      };
    },
    percentCoverage() {
      return {
        portfolio: this.formatNumber(this.coverage.portfolio),
        benchmark: this.formatNumber(this.coverage.benchmark),
      };
    },
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString('en-US', { style: 'percent' });
    },
  },
};
</script>
